// @ts-nocheck
class HeroBannerCarousel extends HTMLElement {
  connectedCallback() {
    // Wait for Swiper to be available (loaded via defer)
    if (typeof Swiper === 'undefined') {
      document.addEventListener('DOMContentLoaded', () => this._init(), { once: true });
      window.addEventListener('load', () => this._init(), { once: true });
      // Fallback poll in case both events already fired
      const check = setInterval(() => {
        if (typeof Swiper !== 'undefined') { clearInterval(check); this._init(); }
      }, 50);
      return;
    }
    this._init();
  }

  _init() {
    if (this._swiper) return; // already initialised

    const wrapper = this.querySelector('.hbc__swiper');
    if (!wrapper) return;

    // Ensure videos are muted — browsers ignore HTML muted attr sometimes
    this.querySelectorAll('.hbc__slide-video').forEach((v) => { v.muted = true; });

    const slidesPerViewMobile  = parseFloat(this.dataset.colsMobile)  || 1;
    const slidesPerViewTablet  = parseFloat(this.dataset.colsTablet)  || 2;
    const slidesPerViewDesktop = parseFloat(this.dataset.colsDesktop) || 3;
    const gap = parseInt(this.dataset.gap, 10) || 16;

    this._swiper = new Swiper(wrapper, {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: gap,
      grabCursor: true,
      // Needed so `swiper.visibleSlides` reports every slide on screen, not
      // just the single "active" one — matters here because slidesPerView
      // is often > 1 (multiple video blocks can be visible at once).
      watchSlidesProgress: true,
      navigation: {
        prevEl: this.querySelector('.hbc__arrow--prev'),
        nextEl: this.querySelector('.hbc__arrow--next'),
      },
      pagination: {
        el: this.querySelector('.hbc__pagination'),
        type: 'bullets',
        bulletClass: 'hbc__pagination-seg',
        bulletActiveClass: 'hbc__pagination-seg--active',
        clickable: false,
        renderBullet: (index, className) => `<div class="${className}"></div>`,
      },
      breakpoints: {
        560: { slidesPerView: slidesPerViewTablet },
        1024: { slidesPerView: slidesPerViewDesktop },
      },
      on: {
        init: (swiper) => this._playVisibleVideos(swiper),
        slideChangeTransitionEnd: (swiper) => this._playVisibleVideos(swiper),
        breakpoint: (swiper) => this._playVisibleVideos(swiper),
      },
    });
  }

  // Plays the video in every slide Swiper currently reports as visible —
  // there can be more than one at once when slidesPerView > 1 — and pauses
  // the rest so off-screen videos don't keep running in the background.
  _playVisibleVideos(swiper) {
    const visibleSlides = new Set(swiper.visibleSlides || []);

    this.querySelectorAll('.hbc__slide-video').forEach((v) => {
      const slide = v.closest('.swiper-slide');
      if (slide && visibleSlides.has(slide)) {
        v.play().catch(() => {
          const resume = () => { v.play().catch(() => {}); };
          document.addEventListener('pointerdown', resume, { once: true });
        });
      } else if (!v.paused) {
        v.pause();
      }
    });
  }

  disconnectedCallback() {
    this._swiper?.destroy(true, true);
    this._swiper = null;
  }
}

if (!customElements.get('hero-banner-carousel')) {
  customElements.define('hero-banner-carousel', HeroBannerCarousel);
}
